/* eslint-disable no-unused-expressions */
import { Component } from 'react';
import { FormControl, FormGroup, FormLabel, InputGroup } from 'react-bootstrap';
import { actions, Control, Errors } from 'forms/rrf';
import PropTypes from 'prop-types';

import './file-upload.css';

class FileUpload extends Component {
  handleFileChange = (model, value) => {
    const reader = new FileReader();
    const file = value[0];

    if (!file) {
      return null;
    }

    const fileSize = this.checkFileSize(file.size);
    const fileType = this.checkFileType(file.type);

    const errors = [];

    if (!fileSize) {
      errors.push('size');
    }

    if (!fileType && this.props.type) {
      errors.push('type');
    }

    if (!errors.length) {
      reader.onloadend = () => {
        this.setState({
          file,
        });
        this.props.onFileLoaded && this.props.onFileLoaded(file, reader.result);
      };

      reader.readAsDataURL(file);
    } else {
      this.setState({
        file: {},
      });
      this.props.onFileLoaded && this.props.onFileLoaded(null);
    }

    return (dispatch) => {
      dispatch(actions.change(model, file));
    };
  };

  checkFileType = type => !type || !this.props.type || this.props.type.some(val => val === type);
  checkFileSize = size => !size || !this.props.sizeLimit || size < this.props.sizeLimit;

  reset = () => {
    this.setState({file: {name: ''}});
  };

  constructor(props) {
    super(props);

    this.state = { file: { name: '' } };
  }

  render() {
    return (
      <div className="ignite-fileupload form-group">
        <h4>
          {this.props.label}
          {this.props.required && '*'}
        </h4>
        <FormGroup className="form-group">
          <InputGroup>
            <FormControl
              type="text"
              value={this.props.showFileNameInTextField ? this.state.file.name : ''}
              readOnly
            />
            <FormLabel className="red-btn btn btn-default" htmlFor={this.props.model}>
              {this.props.buttonHasIcon && <i className="fa fa-folder-open"/>}
              {this.props.buttonLabel}
            </FormLabel>
          </InputGroup>
        </FormGroup>
        <Control.file
          changeAction={this.handleFileChange}
          className="fileInput"
          id={this.props.model}
          model={this.props.model}
          name={this.props.model}
          validators={{
            fileSize: val => !val || this.checkFileSize(val.size),
            fileType: val => !val || this.checkFileType(val.type),
            required: val => !this.props.required || this.props.source || val
          }}
        />
        <Errors
          className="errors"
          messages={{
            fileSize: `The selected file reaches the upload limit (${this.props.sizeLimit / 1024} Kb)`,
            fileType: 'The selected file is not a valid file',
            required: 'This field is required'
          }}
          model={this.props.model}
          show={{touched: true}}
        />
      </div>
    );
  }
}

FileUpload.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  onFileLoaded: PropTypes.func,
  type: PropTypes.arrayOf(PropTypes.string),
  sizeLimit: PropTypes.number,
  buttonLabel: PropTypes.string,
  buttonHasIcon: PropTypes.bool,
  required: PropTypes.bool,
  showFileNameInTextField: PropTypes.bool
};

FileUpload.defaultProps = {
  model: '.file',
  label: 'Upload a file',
  buttonLabel: 'Browse…',
  buttonHasIcon: true,
  showFileNameInTextField: true
};

export default FileUpload;
